export default "__VITE_ASSET__Dep4k0fO__"